import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { Component, ViewContainerRef, ElementRef, ViewChild } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { Observable } from 'rxjs/Observable';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateConverter } from '../../common/service/ngbDateConverter.utils';
import { BiUrls } from '../../biUrls';
import { DateTimeUtils } from '../../../shared';

@Component({
    selector: 'target',
    templateUrl: 'target.component.html',
})

export class targetComponent {

    @ViewChild('file')
    fileInput : ElementRef;

    public trgData: any = { id: null, userId: null, pageSectionId: null, deleted: false };
    public mainPage: boolean = true;
    public trgPage: boolean = false;
    public trgList: any = [];
    public corMasTrgList: any = [];
    public corDetTrgList: any[][] = [];
    public dimLvlList: any[][] = [];
    public dimList: any = [];
    public datePickerList: any = [];
    public filteredDimList: any = [];
    public uploadedDataList: any = [];
    public nonExistentTargets: any = [];
    public dimGroupIndexArray: any = [];
    public nonExistentDimensions: any[][] = [];
    public nonExistentDimLevels: any[][] = [];
    public saveButton: boolean = false;
    public saveFlag: boolean = false;
    public searchBar: boolean[][] = [];
    public accessDenied: boolean = false;
    public onStart: boolean = false;
    public isEdit: boolean = false;
    public dimGroupExists: boolean = false;
    public totalDimGroups: number = 0;
    public trgReg: string = '';
    public lastRegex: string = '';
    public file: any = null;
    public formdata: FormData;
    public measureList: any = [];
    public selectedMeasureId: number = 1;
    public totalPages: number = 0;
    public loader: boolean = false;
    public uploadSucess: boolean = false;

    public trgAdd: boolean = false;
    public corTrgData: any = { id: '', name: '', corTrgCode: '', value: '', corMasTargets: [] };
    public selectedCorTarget: any = { id: '', name: '', corTrgCode: '', value: '', corMasTargets: [] };
    public corMasTargetData: any = { id: '', date: '', value: 0, corDetTargets: [] };
    public dimRegex: string = '';
    public selectedDimMap: any = new Map();

    public dimTree = {
        id: null,
        name: null,
        children: null,
        trgValue: null
    };

    public trgTree = {
        id: null,
        name: null,
        children: null,
        trgValue: null,
        dateId: null,
        dmLvlId: null,
        dmLvlVal: null
    };

    nodes = [];
    options = { displayField: 'trgValue' };


    public totalComb: number = 0;

    constructor(
        public _sanitizer: DomSanitizer,
        public targetService: MDMService,
        public toastr: ToasterComponent,
        public ngbDataConv: NgbDateConverter,
        public vcr: ViewContainerRef) {
        this.toastr.setViewRef(vcr);
    }

    public sPage: number = 0;
    public pageNo: number = 0;
    public pageSize: number = 10;
    public selectedCorTrgId: number;
    public totalCorTrgs: number = 0;
    public currentPage: number = 1;
    public startingPage: number = 0;
    public endingPage: number = 10;

    public mPageNo: number = 0;
    public mSize: number = 10;
    public startingMPage: number = 0;
    public endingMPage: number = 10;
    public currentMPage: number = 1;
    public totalMasTrgs: number = 0;

    @ViewChild('autoCompletediv') elementDiv: ElementRef;

    ngOnInit() {
        //this.mainPage = true;
        if (this.targetService.isBIAdmin) {
            this.loadTargets();
        } else {
            this.accessDenied = true;
        }
    }

    public entityOps(event) {
        if (this.selectedCorTrgId == null) {
            this.selectedCorTrgId = event.target.id;
        } else {
            this.selectedCorTrgId = null;
        }
    }

    public closeDropDown(event){
        this.selectedCorTrgId = null;
    }

    public onPageChange(event: number): void {
        console.log('On Page Change Controller ...');

        if (this.isEdit) {
            this.currentMPage = event;
            this.mPageNo = this.currentMPage - 1;
            this.loadMasTrgsById(this.selectedCorTarget.id);
            this.setEndingPage(this.currentMPage, this.mSize, this.startingMPage, this.endingMPage, this.totalMasTrgs);
        } else {
            this.currentPage = event;
            this.pageNo = this.currentPage - 1;
            if (this.trgReg != '') {
                this.searchPTarget();
            } else {
                this.loadTargets();
            }
            this.setEndingPage(this.currentPage, this.pageSize, this.startingPage, this.endingPage, this.totalCorTrgs);
        }
    }

    public OnPageSizeChanged(event) {
        console.log('On Page-Size Change Controller ...');
        if (this.isEdit) {
            this.mSize = event.target.value;
            let maxPage = Math.floor(this.totalMasTrgs / this.mSize);
            if (maxPage < this.mPageNo) {
                this.mPageNo = maxPage;
            }
            this.loadMasTrgsById(this.corTrgData.id);

        } else {
            this.pageSize = event.target.value;
            let maxPage = Math.floor(this.totalCorTrgs / this.pageSize);
            if (maxPage < this.pageNo || maxPage < this.sPage) {
                this.pageNo = maxPage;
                this.sPage = this.pageNo;
            }
            this.loadTargets();
        }
    }

    public setEndingPage(currPage, size, startPage, endPage, total) {
        let self = this;
        if (currPage == 1) {
            startPage = 0;
            if (total > size) {
                endPage = size;
            } else {
                endPage = total;
            }
        } else {
            startPage = 0 + ((currPage - 1) * + size);
            endPage = +size + ((currPage - 1) * +size);
            if (endPage > total) {
                endPage = total;
            }
        }

        if (self.isEdit) {
            self.currentMPage = currPage;
            self.startingMPage = startPage;
            self.endingMPage = endPage;
        } else {
            self.currentPage = currPage;
            self.startingPage = startPage;
            self.endingPage = endPage;
        }
    }

    public searchPTarget() {
        return new Promise((resolve) => {
            let self = this;
            self.mainPage = true;
            self.loader = true;
            self.trgList = [];
            if (self.trgReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            } else {
                self.sPage = self.currentPage - 1;
                //self.currentPage = 1;
            }
            self.lastRegex = self.trgReg;
            let resu = self.targetService.search(BiUrls.TARGET, BiUrls.SEARCH_P_TARGET,
                self.trgReg, self.sPage, self.pageSize).then((res) => {
                    self.loadSearchedPTargets(res);
                    self.loader = false;
                }, (err) => {
                    console.error(err);
                });
            resolve('completed');
        });
    }

    // By Lalu
    public loadSearchedPTargets(res) {
        let self = this;
        self.trgList = (res != undefined) ? res.data.pageElements : [];
        self.totalCorTrgs = (res != undefined) ? res.data.total : 0;
        self.setEndingPage(self.currentPage, self.pageSize, self.startingPage, self.endingPage, self.totalCorTrgs);
    }

    loadTargets() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            this.targetService.getDataByPage(BiUrls.TARGET, self.pageNo, self.pageSize).then((res) => {
                self.trgList = [];
                if (res == undefined || res.data == undefined) {
                    self.toastr.showError('No Targets to load');
                } else {
                    self.trgList = res.data.pageElements != undefined ? res.data.pageElements : [];
                    self.selectedCorTarget = self.trgList[0];
                    self.totalCorTrgs = res.data.total;
                }
                self.loader = false;
                self.mainPage = true;
                self.setEndingPage(self.currentPage, self.pageSize, self.startingPage, self.endingPage, self.totalCorTrgs);
                resolve('completed');
            }, (error) => {
                if (error.status == 204) {
                    self.toastr.showError('Cannot load the targets');
                }
            });
        });
    }

    onBack() {
        this.mainPage = true;
        this.trgPage = false;
        this.trgData = {};
        this.isEdit = false;
        this.corMasTrgList = [];
        this.corDetTrgList = [];
        this.dimLvlList = [];
        this.searchBar = [];
    }

    bulkUpload(event) {
        let self = this;
        self.dimGroupIndexArray = [];
        self.dimGroupExists = false;
        self.totalDimGroups = 0;
        self.nonExistentDimensions = [];
        self.nonExistentDimLevels = [];
        self.nonExistentTargets = [];
        self.uploadedDataList = [];
        if (self.validateFile(self.file)) {
            let formdata1 = new FormData();
            formdata1.append('file', self.file);
            self.targetService.bulkUpload(BiUrls.TARGET, BiUrls.BULKUPLOAD_TARGET, formdata1).then(
                (res) => {
                    if (res.success) {
                        self.toastr.showSuccess("Bulk Upload Successful");
                        self.uploadSucess = true;
                        self.file = null;
                        self.fileInput.nativeElement.value = null;
                        self.loadUploadReport(res);
                        self.loadTargets();
                    } else {
                        self.toastr.showError(res.errorMessage);
                    }
                }, (error) => {
                    self.toastr.showError('Bulk Upload Failed');
                });
        } else {
            self.toastr.showError('Please Attach An Excel File');
        }

    }

    public validateFile(file) {
        let ext;
        if (file != null) {
            ext = file.name.split('.', 2);
        } else {
            ext = undefined;
        }
        if (ext == undefined || !(ext[1] == 'xls' || ext[1] == 'xlsx')) {
            return false;
        } else {
            return true;
        }
    }

    loadUploadReport(result) {
        let self = this;
        let statusMap = this.jsonToMap(result);
        this.nonExistentTargets = statusMap.get('NON_EXISTENT_TRG_CODE');
        if (statusMap.size > 2) {
            this.dimGroupExists = true;
            this.totalDimGroups = statusMap.size / 2 - 1;
        }
        for (let i = 0; i < this.totalDimGroups; i++) {
            this.dimGroupIndexArray[i] = i + 1;
            this.nonExistentDimensions[i] = statusMap.get('NON_EXISTENT_DIM_CODE_' + (i + 1));
            this.nonExistentDimLevels[i] = statusMap.get('NON_EXISTENT_DIM_LVL_NAME_' + (i + 1));
        }
        this.uploadedDataList = statusMap.get('UPLOADED_DATA');
    }

    jsonToMap(result: any) {
        let res = result;
        let jsonObj = JSON.parse(JSON.stringify(res.data));
        let map = new Map();
        for (let k of Object.keys(jsonObj)) {
            map.set(k, jsonObj[k]);
        }
        return map;
    }

    fileChange(event) {
        this.file = event.target.files[0];
        console.log(this.file.name);
    }

    // strToDateId(dateStr): number {
    //     let dateArr = dateStr.split("-", 3);
    //     let dateIdStr = dateArr[0] + dateArr[1] + dateArr[2];
    //     let dateId = parseInt(dateIdStr);
    //     return dateId;
    // }

    dateIdToStr(dateId): string {
        let dstr = dateId.toString();
        let date = DateTimeUtils.toDate(dstr);
        let d = date.getUTCDate();
        let m = date.getUTCMonth() + 1;
        let y = date.getUTCFullYear();
        let dateStr = d + "-" + m + "-" + y;
        return dateStr;
    }

    // public onDateChange(event, corMasTrgInd) {
    //     //this.corMasTrgList[corMasTrgInd]['date'] = this.strToDateId(event.target.value);
    //     this.corMasTrgList[corMasTrgInd]['date'] = this.strToDateId(event.target.value);
    //     this.datePickerList[corMasTrgInd] = false;
    // }

    public removeSelectedDate(corMasInd) {
        this.datePickerList[corMasInd] = true;
    }

    public searchDim = (keyword: any): Observable<any[]> => {
        let self = this;
        this.targetService.isBIAdmin = false;
        this.targetService.search(BiUrls.BI_DIMENSION, BiUrls.SEARCH_DIMENSION, keyword).then(
            (res) => {
                self.totalPages = 0;
                if (res != undefined) {
                    self.dimList = res.data != undefined ? res.data : [];
                }
            }, (err) => {
                console.error(err);
            });
        this.targetService.isBIAdmin = true;
        //this.elementDiv.nativeElement.value = '';
        return Observable.of(self.dimList);
    }

    orgNameValueFormatter(data: any): string {
        return `${data.dimHierachyLevelName}`;
    }

    autoCompleteListFormatter = (data: any): SafeHtml => {
        let html = `<span>${data.dimHierarchyLevelName}-${data.dimName}-${data.dimCode}</span>`;
        //let html = `<span> ${data.dimName} -- ${data.dimCode}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);

    }

    onSelectDim(event, corDetTrg, corMasInd, corDetInd) {
        this.searchBar[corMasInd][corDetInd] = false;
        corDetTrg.dimId = event.dimId;
        corDetTrg.dimLvlId = event.dimHierarchyLevelId;
        this.dimLvlList[corMasInd][corDetInd] = event.dimHierarchyLevelName;
        this.dimList = [];
    }

    removeSelectedDim(corMasInd, corDetInd) {
        this.searchBar[corMasInd][corDetInd] = true;
    }

    // genTrgTree() {
    //     let self = this;
    //     let msTrgs = self.selectedCorTarget.corMasTargets;
    //     let node = null;
    //     let mtNodeList = [];
    //     let detNodeList = [];
    //     let trgList = [];
    //     for (let mt of msTrgs) {
    //         let detTrgs = mt.corDetTargets;
    //         let mtNode;
    //         detNodeList = [];
    //         for (let dt of detTrgs) {
    //             let detNode = {
    //                 id: dt.id,
    //                 children: [],
    //                 dmLvlId: dt.dimLvlId,
    //                 dmLvlValue: dt.dimLvlValue
    //             }
    //             detNodeList.push(detNode);
    //         }
    //         mtNode = {
    //             id: mt.id,
    //             dateId: mt.date,
    //             trgValue: mt.value,
    //             children: detNodeList
    //         }
    //         mtNodeList.push(mtNode);
    //     }
    //     this.trgTree = {
    //         id: this.selectedCorTarget.id,
    //         name: this.selectedCorTarget.name + " ( " + this.selectedCorTarget.corTrgCode + " )",
    //         dateId: null,
    //         dmLvlId: null,
    //         dmLvlVal: null,
    //         children: mtNodeList,
    //         trgValue: null
    //     }
    //     trgList.push(this.trgTree);
    //     this.nodes = trgList;
    // }

    public onCloseSummary(event) {
        this.uploadSucess = false;
        //this.loadTargets();
    }

    public addCorTarget(event) {
        let self = this;
        self.mainPage = false;
        self.trgPage = true;
        self.corTrgData = { id: null, name: '', deleted: false, corMasTargets: [] }
    }

    public onSave() {
        let self = this;
        self.saveFlag = true;
        let validate: any = self.validater();
        if (validate != '') {
            self.toastr.showError(validate);
        } else {
            self.loader = true;
            self.saveButton = true;
            self.parseMasTrgDates();
            if (self.isEdit) {
                console.log('ON EDIT');
                for (let i = 0; i < self.corMasTrgList.length; i++) {
                    self.corMasTrgList[i].corDetTargets = self.corDetTrgList[i];
                }
                self.selectedCorTarget.corMasTargets = self.corMasTrgList;
                self.targetService.update(BiUrls.TARGET, self.selectedCorTarget).then((res) => {
                    self.loadAfterSaveOrEdit(res, 'edit');
                });
            } else {
                console.log('ON SAVE');
                for (let i = 0; i < self.corMasTrgList.length; i++) {
                    self.corMasTrgList[i].corDetTargets = self.corDetTrgList[i];
                }
                self.corTrgData.corMasTargets = self.corMasTrgList;
                self.targetService.save(BiUrls.TARGET, self.corTrgData).then((res) => {
                    self.loadAfterSaveOrEdit(res, 'new');
                });
            }
        }
    }

    public loadAfterSaveOrEdit(result, type) {
        let self = this;
        self.totalPages = Math.floor(self.totalCorTrgs / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo :
            self.totalPages;
        self.currentPage = self.pageNo + 1;
        let text = type == 'new' ? 'Cor-Target saved successfully' : 'Changes saved successfully';
        if (self.trgReg != '') {
            self.searchPTarget().then((res) => {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                } else {
                    self.toastr.showError('Failed to save Cor-Target');
                }
            })
        } else {
            self.loadTargets().then((res) => {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                } else {
                    self.toastr.showError('Failed to save Cor-Target');
                }
            }, (error) => {
                console.error(error);
            });
        }
    }

    public setPageFieldsAfterLoading() {
        let self = this;
        self.saveButton = false;
        self.saveFlag = false;
        self.mainPage = true;
        self.corMasTrgList = [];
        self.corDetTrgList = [];
        self.dimLvlList = [];
        self.searchBar = [];
        self.trgPage = false;
        self.isEdit = false;
        self.loader = false;
    }

    public setTrgComponentFields(corTrgData) {
        let self = this;
        self.isEdit = true;
        self.loader = false;
        self.mainPage = false;
        self.trgPage = true;
        self.selectedCorTarget = corTrgData;
        self.corMasTrgList = self.selectedCorTarget.corMasTargets;
        self.parseMasTrgDates();
        for (let i = 0; i < self.corMasTrgList.length; i++) {
            self.searchBar.push([]);
            self.dimLvlList.push([]);
            //self.datePickerList[i] = false;
            self.corDetTrgList.push(self.corMasTrgList[i].corDetTargets);
            for (let j = 0; j < self.corDetTrgList[i].length; j++) {
                self.searchBar[i][j] = false;
                self.dimLvlList[i][j] = self.corDetTrgList[i][j].dimLvlId;
            }
        }
    }

    public loadMasTrgsById(corTrgId): any {
        let self = this;
        let url = BiUrls.GET_P_MAS_TRGS + corTrgId;
        self.targetService.getDataByPage(url, self.mPageNo, self.mSize).then((res) => {
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load the Cor-Target');
                self.loadTargets();
            } else {
                self.corTrgData.corMasTargets = JSON.parse(JSON.stringify(res.data.pageElements));
                self.setTrgComponentFields(self.corTrgData);
                //self.genTrgTree();
                self.totalMasTrgs = res.data.total;
                self.setEndingPage(self.currentMPage, self.mSize, self.startingMPage, self.endingMPage, self.totalMasTrgs);
            }
        }, (err) => {
            console.error(err);
        })
    }

    public parseMasTrgDates() {
        let self = this;
        if (self.saveFlag == true) {
            for (let cmt of self.corMasTrgList) {
                let strMon = cmt.date.month.toString();
                let month = strMon.length == 1 ? ('0' + strMon) : strMon;
                let strDay = cmt.date.day.toString();
                let day = strDay.length == 1 ? ('0' + strDay) : strDay;
                let strDate = cmt.date.year.toString() + month + day;
                cmt.date = parseInt(strDate);
            }
        } else {
            for (let cmt of self.corMasTrgList) {
                let strDate = self.dateIdToStr(cmt.date);
                cmt.date = this.ngbDataConv.fromModel(strDate);
            }
        }
    }

    public editCorTarget(corTrg) {
        console.log('On Edit Controller ...');
        let self = this;
        self.mainPage = false;
        self.trgPage = true;
        self.isEdit = true;
        self.loader = true;
        self.selectedCorTrgId = null;
        let url = BiUrls.GET_TRGS_WITHOUT_HIERARCHY + corTrg.id;
        self.targetService.getDataByPage(url, self.pageNo, self.pageSize).then((res) => {
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load the Cor-Target');
                self.loadTargets();
            } else {
                self.corTrgData = res.data;
                self.loadMasTrgsById(corTrg.id);
                self.setEndingPage(self.currentMPage, self.mSize, self.startingMPage, self.endingMPage, self.totalMasTrgs);
            }
            self.loader = false;
        }, (error) => {
            console.error(error);
        });
    }

    public addMasTarget(corTrg) {
        let corMasTrg: any = {
            id: null, date: null, value: null,
            corTargetId: 0, corDetTargets: [], deleted: false
        }
        corMasTrg.corTargetId = corTrg.id;
        this.corMasTrgList.push(corMasTrg);
        this.corDetTrgList.push(corMasTrg.corDetTargets);
        this.searchBar.push([]);
        this.datePickerList.push(true);
        this.dimLvlList.push([]);
    }

    public addDetTarget(corMasInd) {
        let corDetTrg: any = {
            id: null, dimLvlId: 0, dimLvlValue: '',
            corMasTrgId: this.corMasTrgList[corMasInd]['id'], deleted: false
        }
        this.searchBar[corMasInd].push(true);
        this.corDetTrgList[corMasInd].push(corDetTrg);
    }

    public searchBarVisibility(corMasInd, corDetInd) {
        return this.searchBar[corMasInd][corDetInd];
    }

    public removeCorTrg(corTrg) {
        let r = confirm('Are you sure you want to remove the Cor-Target ' + corTrg.name + ' ?');
        if (r == true) {
            this.delete(corTrg);
        }
    }

    public delete(corTrg) {
        let self = this;
        self.targetService.delete(BiUrls.TARGET, corTrg.id).then((response) => {
            self.loader = false;
            self.pageNo = self.trgList.length == 1 ?
                self.totalCorTrgs == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadTargets();
            if (response == undefined || response.data == undefined) {
                self.toastr.showError('Unable to remove Cor-Target');
            } else {
                self.toastr.showSuccess(corTrg.name + ' removed successfully');
            }
        }, (error) => {
            console.error(error);
        });
    }

    public removeMasTarget(corMasTrg) {
        let index = this.corMasTrgList.indexOf(corMasTrg);
        this.corMasTrgList.splice(index, 1);
        this.corDetTrgList.splice(index, 1);
        this.searchBar.splice(index, 1);
        this.dimLvlList.splice(index, 1);
    }

    public removeDetTarget(corDetTrg, corMasInd) {
        let index = this.corDetTrgList[corMasInd].indexOf(corDetTrg);
        this.corDetTrgList[corMasInd].splice(index, 1);
        this.searchBar[corMasInd].splice(index, 1);
        this.dimLvlList[corMasInd].splice(index, 1);
    }

    public validater() {
        if (this.corTrgData.name == undefined || this.corTrgData.name.trim() == '') {
            return 'Please enter the name for Cor-Target';
        } else if (this.corMasTrgList.length > 0) {
            return this.masTrgValidator();
        } else {
            this.corTrgData.name = this.corTrgData.name.trim();
            return '';
        }
    }

    public masTrgValidator() {
        let msg ='';
        for(let i=0;i<this.corMasTrgList.length;i++){
            let cmt = this.corMasTrgList[i];
            if (cmt.date == null) {
                return 'Please Select Mas Target Date';
            }
            if (cmt.value == undefined) {
                return 'Please Specify Target Value';
            }
            if (this.corDetTrgList[i].length>0){
                msg = this.detTrgValidator(this.corDetTrgList[i]);
            }
            if(msg !=''){
                return msg;
            }
        }
        return msg;
    }

    public detTrgValidator(detTrgList) {
        for (let cdt of detTrgList) {
            if (cdt.dimId == undefined) {
                return 'Please Select Dimension';
            } else if (cdt.dimLvlValue == undefined || cdt.dimLvlValue.trim()=='') {
                return  'Please Specify Dimension Level Value';
            }
        }
        return '';
    }

    /* nodes = [
       {
         id: 1,
         name: 'root1',
         children: [
           { id: 2, name: 'child1' },
           { id: 3, name: 'child2' }
         ]
       },
       {
         id: 4,
         name: 'root2',
         children: [
           { id: 5, name: 'child2.1' },
           {
             id: 6,
             name: 'child2.2',
             children: [
               { id: 7, name: 'subsub' }
             ]
           }
         ]
       }
     ]; */

    /* genDimTree() {
        let self = this;
        let dim, lvls, prevDim, prevLvls;
        let nodeList = [];
        for (let i = (self.filteredDimList.length - 1); i >= 0; i--) {
            dim = self.filteredDimList[i];
            let prevNodeList = nodeList;
            nodeList = [];
            lvls = dim.dimHierarchyData[0].dimHierarchyLevelData;
            let node;
            for (let j = 0; j < lvls.length; j++) {
                if (i == (self.filteredDimList.length - 1)) {
                    node = { id: self.totalComb, name: lvls[j].displayName, trgValue: 100 };
                } else {
                    node = {
                        id: self.totalComb, name: lvls[j].displayName,
                        children: prevNodeList, trgValue: 250
                    };
                }
                self.totalComb++;
                nodeList.push(node);
            }
        }
        self.dimTree = { id: 9999, name: 'RootNode', children: nodeList, trgValue: 999 };
        //self.nodes = self.dimTree.children;
    }*/

}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/target.component.ts